import { Component, input } from '@angular/core';

@Component({
  selector: 'app-product-specs',
  imports: [],
  templateUrl: './product-specs.html',
  styleUrl: './product-specs.scss',
})
export class ProductSpecs {
  specs = input<any>();

}
